export default __webpack_public_path__ + "static/aws-logo-84d24e4e1708dc95aacf8e2abe1666cd.png";